import {ApolloLink} from 'apollo-link';
import {SEARCH_REQUEST_QUERY_NAME} from '../queries/searchRequestQuery';

const PREFETCHED_QUERIES = [SEARCH_REQUEST_QUERY_NAME];

const isPrefetchOperation = (operation) =>
    PREFETCHED_QUERIES.includes(operation.operationName);

export class PrefetchLink extends ApolloLink {
    constructor() {
        super();
        this.isPageLoadSearch = true;
    }
    request(operation, forward) {
        if (isPrefetchOperation(operation)) {
            operation.extensions.isPageLoadSearch = this.isPageLoadSearch;
            this.isPageLoadSearch = false;
        }
        return forward(operation);
    }
}
